import React, { useState, useEffect, useRef } from "react";
import { observer } from "mobx-react-lite";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
  Button,
  TextField,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CircularProgress from "@mui/material/CircularProgress";
import { addDays, startOfWeek, format, subWeeks, addWeeks } from "date-fns";
import Api from "../Api";
import { BASE_API_URL } from "../const";
import filmStore from "../../Store/FilmStore";
import { toast } from "react-toastify";

const MainProgrammaPeredach = ({ responseListChannels, hideMetUid }) => {
  const [currentWeek, setCurrentWeek] = useState(new Date());
  const [selectedChannel, setSelectedChannel] = useState(null);
  const [responseAPI, setResponseAPI] = useState();
  const [editedData, setEditedData] = useState();
  const [selectedDay, setSelectedDay] = useState(null);
  const [loadingData, setLoadingData] = useState(false);
  const [selectedAddId, setSelectedAddId] = useState(null);
  const [currentTime, setCurrentTime] = useState(() => new Date());
  const scheduleContainerRef = useRef(null);
  const currentProgramRowRef = useRef(null);
  const selectedChannelData = responseListChannels.find(
    (channel) => Number(channel.id) === Number(selectedChannel)
  );
  const canEditTimeline = selectedChannelData?.rotation === "stream";

  const daysOfWeek = Array.from({ length: 7 }, (_, i) =>
    format(
      addDays(startOfWeek(currentWeek, { weekStartsOn: 1 }), i),
      "yyyy-MM-dd"
    )
  );
  const dayLabels = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];

  const isTodaySelected = selectedDay === format(currentTime, "yyyy-MM-dd");

  const getProgramStartTime = (item) => {
    const value = item.start_at || item.start;
    if (!value || !selectedDay) return Number.NaN;

    const dateTimeMatch = String(value).match(
      /^(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?/
    );
    if (dateTimeMatch) {
      const [, year, month, day, hours, minutes, seconds = "0"] =
        dateTimeMatch;
      return new Date(
        Number(year),
        Number(month) - 1,
        Number(day),
        Number(hours),
        Number(minutes),
        Number(seconds)
      ).getTime();
    }

    const timeMatch = String(value).match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?/);
    if (!timeMatch) return Number.NaN;
    const [year, month, day] = selectedDay.split("-").map(Number);
    const [, hours, minutes, seconds = "0"] = timeMatch;
    return new Date(
      year,
      month - 1,
      day,
      Number(hours),
      Number(minutes),
      Number(seconds)
    ).getTime();
  };

  const currentProgramIndex = isTodaySelected
    ? (editedData || []).reduce((currentIndex, item, index) => {
        const startTime = getProgramStartTime(item);
        return Number.isFinite(startTime) && startTime <= currentTime.getTime()
          ? index
          : currentIndex;
      }, -1)
    : -1;

  useEffect(() => {
    const timer = window.setInterval(() => setCurrentTime(new Date()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  useEffect(() => {
    if (!isTodaySelected || currentProgramIndex < 0) return undefined;

    const centerTimer = window.setTimeout(() => {
      const container = scheduleContainerRef.current;
      const row = currentProgramRowRef.current;
      if (!container || !row) return;

      const top =
        row.offsetTop - container.clientHeight / 2 + row.offsetHeight / 2;
      container.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    }, 1000);

    return () => window.clearTimeout(centerTimer);
  }, [currentProgramIndex, isTodaySelected]);

  useEffect(() => {
    if (responseAPI) {
      setEditedData(responseAPI.map((item) => ({ ...item }))); // Создаем копию данных
    }
  }, [responseAPI]);

  useEffect(() => {
    console.log("responseListChannels ", JSON.stringify(responseListChannels));
  }, [responseListChannels]);

  const getNextMonday = () => {
    // Если selectedDay не определён, используем текущую дату
    const referenceDate = selectedDay || new Date();
    const nextMonday = startOfWeek(addWeeks(referenceDate, 1), {
      weekStartsOn: 1,
    }); // Получаем дату следующего понедельника
    return format(nextMonday, "yyyy-MM-dd"); // Форматируем дату
  };

  const getPreviousSunday = () => {
    // Если selectedDay не определён, используем текущую дату
    const referenceDate = selectedDay || new Date();
    // Получаем предыдущую неделю
    const previousWeek = subWeeks(referenceDate, 1);
    // Находим конец недели (воскресенье)
    const previousSunday = addDays(
      startOfWeek(previousWeek, { weekStartsOn: 1 }),
      6
    );
    return format(previousSunday, "yyyy-MM-dd");
  };

  const handlePreviousWeek = () => {
    setCurrentWeek((prev) => subWeeks(prev, 1));
    if (!selectedChannel) return;
    const previousSundayDate = getPreviousSunday();
    setSelectedDay(previousSundayDate);
    fetchProgramData(selectedChannel, previousSundayDate);
  };

  const handleNextWeek = () => {
    setCurrentWeek((prev) => addWeeks(prev, 1));
    if (!selectedChannel) return;
    const nextMondayDate = getNextMonday();
    setSelectedDay(nextMondayDate);
    fetchProgramData(selectedChannel, nextMondayDate);
  };

  const handleRowClick = (element) => {
    setSelectedChannel(element.id);

    if (element.end_program_date && element.end_program_date.includes(" ")) {
      const dateOnly = element.end_program_date.split(" ")[0];
      const endDate = new Date(dateOnly);

      // Считаем начало недели, в которую попадает end_program_date
      const startOfTargetWeek = startOfWeek(endDate, { weekStartsOn: 1 });

      // Обновляем текущую неделю, чтобы нужная дата попала в диапазон дней
      setCurrentWeek(startOfTargetWeek);

      // Устанавливаем выбранный день и загружаем данные
      setSelectedDay(dateOnly);
      fetchProgramData(element.id, dateOnly);
    }
  };

  // Функция для обработки нажатия на кнопку с днем
  const handleDateButtonClick = (date) => {
    if (!selectedChannel) return; // Проверка на наличие выбранного канала
    setSelectedDay(date);
    fetchProgramData(selectedChannel, date);
  };

  // Функция для GET-запроса с использованием выбранного канала и даты
  async function fetchProgramData(channelId, date) {
    setLoadingData(true); // Показываем спиннер
    try {
      const response = await Api.get(
        `${BASE_API_URL}/api/timeline/show/${channelId}?date=${date}`
      );
      setResponseAPI(response.data.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingData(false); // Скрываем спиннер
    }
  }

  const handleMetUidChange = (index, newUid) => {
    setEditedData((prevData) =>
      prevData.map((item, idx) =>
        idx === index ? { ...item, met_uid: newUid } : item
      )
    );
  };

  // Обработчик для подтверждения изменений
  const handleConfirmClick = (index) => {
    const updatedMetUid = editedData[index]?.met_uid;
    console.log("Confirmed met_uid:", updatedMetUid);
    // Здесь добавьте логику для сохранения обновленного met_uid
    setMetUid(editedData[index].movie_id, updatedMetUid);
  };

  async function setMetUid(id, newMetUid) {
    Api.post(`${BASE_API_URL}/api/movie/met/${id}`, {
      met_uid: newMetUid,
    })
      .then((response) => {})
      .catch((error) => {
        console.log("transfer met_uid bad");
        console.error("transfer met_uid bad", error);

        // проверяем есть ли структура с code/message
        const msg =
          error?.response?.data?.error?.message ||
          error?.message ||
          "transfer met_uid bad";

        alert(`Ошибка: ${msg}`);
      });
  }

  async function deleteEpg(channel_id, timeline_id) {
    if (!canEditTimeline) return;
    Api.post(`${BASE_API_URL}/api/timeline/delete/`, {
      channel_id: channel_id,
      timeline_id: timeline_id,
    })
      .then((response) => {
        fetchProgramData(selectedChannel, selectedDay);
      })
      .catch((error) => {
        console.log("transfer deleteEpg bad");
        console.error("transfer deleteEpg bad", error);

        // проверяем есть ли структура с code/message
        const msg =
          error?.response?.data?.error?.message ||
          error?.message ||
          "transfer deleteEpg bad";

        alert(`Ошибка: ${msg}`);
      });
  }
  const handleDelete = async (start, id) => {
    console.log("Deleting item with start time:", start);
    console.log("Channel id: " + selectedChannel);
    console.log("id: " + id);
    // Здесь добавьте логику для удаления элемента из editedData или выполнения API-запроса
    await deleteEpg(selectedChannel, id);
  };

  // === НОВОЕ: обработчик ADD ===
  const handleAdd = (start, id) => {
    if (!selectedChannel || !canEditTimeline) return;

    const current = filmStore.addAfterData;

    // Если уже выбран этот же ID — снимаем выделение
    if (
      current &&
      current.channel_id === selectedChannel &&
      current.timeline_id === id
    ) {
      filmStore.clearAddAfterData();
      setSelectedAddId(null);
      toast.info(`ID ${id} удалён из выбора`, { position: "top-left" });
    } else {
      // Выбираем
      filmStore.setAddAfterData(selectedChannel, id);
      setSelectedAddId(id);
      toast.success(`Выбран файл с id ${id} для канала`, {
        position: "top-left",
      });
    }
  };

  // функция отсекающая длинное название и приклеивающая в конце (сезон серия)
  const formatTitle = (title) => {
    if (!title) return "";

    // Ищем хвост вида "(сезон 1 серия 5)" в конце
    const match = title.match(/\(сезон\s*\d+\s*серия\s*\d+\)$/i);
    const suffix = match ? match[0] : "";
    const base = match ? title.replace(match[0], "").trim() : title;

    const maxLength = 38; // итоговая длина всей строки (включая суффикс и троеточие)

    // Если вместе с хвостом длина превышает лимит
    if (base.length + suffix.length > maxLength) {
      const available = maxLength - suffix.length - 3; // оставляем место под "..."
      return base.slice(0, Math.max(available, 0)) + "..." + " " + suffix;
    }

    return title;
  };

  return (
    <Box>
      {/* Заголовок */}
      <Box
        sx={{
          backgroundColor: "#E0F7FA",
          padding: 2,
          borderRadius: "8px 8px 0 0",
        }}
      >
        <Typography variant="h5" align="center" color="primary">
          Программа передач
        </Typography>
      </Box>

      <Box sx={{ display: "flex", height: "100%" }}>
        {/* Левая часть с каналами */}
        <Box sx={{ width: "25%", padding: 0 }}>
          <TableContainer component={Paper}>
            <Table
              sx={{
                "& .MuiTableCell-root": {
                  padding: "6px 8px", // Уменьшаем отступы
                },
              }}
            >
              <TableBody sx={{ border: "1px solid #ddd" }}>
                {responseListChannels.map((element, index) => (
                  <TableRow
                    key={index}
                    onClick={() => handleRowClick(element)}
                    sx={{
                      cursor: "pointer",
                      "&:hover": { backgroundColor: "#f0f0f0" },
                    }}
                  >
                    <TableCell
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      {element.name}
                      {selectedChannel === element.id && (
                        <CheckIcon
                          sx={{
                            color: "green",
                            fontSize: 20, // Large size for the checkmark
                            marginLeft: 1,
                          }}
                        />
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* Правая часть */}
        <Box sx={{ width: "75%", padding: 2 }}>
          {/* Кнопки с датами */}
          <Box
            sx={{
              display: "flex",
              gap: 1,
              justifyContent: "center",
              marginBottom: 2,
            }}
          >
            {daysOfWeek.map((day, index) => (
              <Button
                key={index}
                variant="contained"
                color={selectedDay === day ? "secondary" : "primary"}
                onClick={() => handleDateButtonClick(day)}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: 80,
                }}
              >
                <Typography variant="body2">{day}</Typography>
                <Typography variant="caption">{dayLabels[index]}</Typography>
              </Button>
            ))}
          </Box>

          {/* Кнопки для переключения недель */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 2,
              marginBottom: 2,
            }}
          >
            <Button variant="outlined" onClick={handlePreviousWeek}>
              Предыдущая неделя
            </Button>
            <Button variant="outlined" onClick={handleNextWeek}>
              Следующая неделя
            </Button>
          </Box>

          {/* Таблица с расписанием */}
          {/* Таблица с расписанием */}
          {loadingData ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="200px"
            >
              <CircularProgress size={60} thickness={5} />
            </Box>
          ) : (
            editedData && (
              <TableContainer
                ref={scheduleContainerRef}
                component={Paper}
                sx={{
                  margin: "auto",
                  marginTop: 4,
                  maxHeight: "calc(100vh - 360px)",
                  overflowY: "auto",
                }}
              >
                <Table
                  sx={{
                    "& .MuiTableCell-root": {
                      padding: "6px 8px",
                    },
                  }}
                >
                  <TableBody>
                    {editedData.map((item, index) => {
                      const params = new URLSearchParams({ id: item.movie_id });
                      const href = `/filmdata?${params.toString()}`;
                      return (
                        <TableRow
                          key={index}
                          ref={
                            index === currentProgramIndex
                              ? currentProgramRowRef
                              : null
                          }
                          sx={{
                            backgroundColor:
                              index === currentProgramIndex
                                ? "#eeeeee"
                                : "transparent",
                            transition: "background-color 200ms ease",
                          }}
                        >
                          <TableCell sx={{ width: "50px" }}>
                            {item.start}
                          </TableCell>

                          <TableCell
                            sx={{
                              maxWidth: 250,
                              minWidth: 250,
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <a
                              href={href}
                              target="_blank"
                              rel="noopener noreferrer"
                              title={item.file}
                              style={{
                                display: "inline-block",
                                maxWidth: "100%",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {formatTitle(item.file)}
                            </a>
                          </TableCell>

                          {!hideMetUid && (
                            <TableCell
                              sx={{ display: "flex", alignItems: "center" }}
                            >
                              <TextField
                                variant="outlined"
                                size="small"
                                value={item.met_uid}
                                onChange={(e) =>
                                  handleMetUidChange(index, e.target.value)
                                }
                                sx={{
                                  marginRight: 1,
                                  flexShrink: 1,
                                  width: "250px",
                                }}
                              />
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={() => handleConfirmClick(index)}
                              >
                                Edit
                              </Button>
                            </TableCell>
                          )}

                          {canEditTimeline && (
                            <>
                              <TableCell>
                                <Button
                                  variant="contained"
                                  color="secondary"
                                  size="small"
                                  onClick={() =>
                                    handleDelete(item.start, item.id)
                                  }
                                >
                                  DELETE
                                </Button>
                              </TableCell>
                              <TableCell>
                                <Button
                                  variant="contained"
                                  color={
                                    selectedAddId === item.id ||
                                    (filmStore.addAfterData &&
                                      filmStore.addAfterData.channel_id ===
                                        selectedChannel &&
                                      filmStore.addAfterData.timeline_id ===
                                        item.id)
                                      ? "success"
                                      : "warning"
                                  }
                                  size="small"
                                  onClick={() => handleAdd(item.start, item.id)}
                                >
                                  ADD
                                </Button>
                              </TableCell>
                            </>
                          )}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default observer(MainProgrammaPeredach);
